interface IPreferencesValues {
  displayLicensePlate: boolean;
  displayServiceCard: boolean;
  useMapMatch: boolean;
  showSignalTour: boolean;
  openSiteVisibility?: boolean;
}

class Preferences {
  private static _PREFERENCES_KEY = 'preferences';

  private static _values: IPreferencesValues;

  private static _initialValues: Readonly<IPreferencesValues> = {
    displayLicensePlate: false,
    displayServiceCard: true,
    useMapMatch: true,
    showSignalTour: true,
    openSiteVisibility: undefined,
  };

  /**
   * @description Initializes preferences
   */
  public static initialize(): void {
    const preferences = localStorage.getItem(this._PREFERENCES_KEY);

    if (!preferences) {
      localStorage.setItem(
        this._PREFERENCES_KEY,
        JSON.stringify(this._initialValues)
      );
      this._values = { ...this._initialValues };
    } else {
      try {
        // cast is needed because JSON.parse returns 'any' and doesn't accept a type argument
        const currentValuesFromStorage = JSON.parse(
          preferences
        ) as IPreferencesValues;

        // Some elements may not exist in the localStorage, as they might be new or deleted, from any sides
        // Therefore, we're assigning over the initialValues to keep a consistent object
        this._values = {
          ...this._initialValues,
          ...currentValuesFromStorage,
        };
      } catch (e) {
        this._values = { ...this._initialValues };
      }
    }
  }

  /**
   * @description Sets preferences
   * @template T
   * @param key
   * @param value
   */
  public static set<T extends keyof IPreferencesValues>(
    key: T,
    value: IPreferencesValues[T]
  ): void {
    this._values[key] = value;
    localStorage.setItem(this._PREFERENCES_KEY, JSON.stringify(this._values));
  }

  /**
   * @description Gets preferences
   * @template T
   * @param key
   * @returns <IPreferencesValues[T]> A preference value
   */
  public static get<T extends keyof IPreferencesValues>(
    key: T
  ): IPreferencesValues[T] {
    return this._values[key];
  }
}

export default Preferences;
